var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0371 0C22.9231 0 22.8062 0.0209975 22.6892 0.0689915L5.39933 7.01612H0.47994C0.215973 7.01612 0 7.2381 0 7.51406V16.4829C0 16.7589 0.215973 16.9809 0.47994 16.9809H3.53056C3.41957 17.3288 3.35958 17.6978 3.35958 18.0727C3.35958 20.0495 4.97338 21.6573 6.95913 21.6573C8.62092 21.6573 10.0217 20.5294 10.4357 19.0056L22.6922 23.931C22.8092 23.976 22.9261 24 23.0401 24C23.5471 24 24 23.5741 24 23.0041V0.995875C23.997 0.425947 23.5471 0 23.0371 0ZM6.95913 19.5066C6.16423 19.5066 5.51931 18.8646 5.51931 18.0727C5.51931 17.7368 5.6363 17.4158 5.84927 17.1609L8.39595 18.1837C8.33596 18.9216 7.71504 19.5066 6.95913 19.5066ZM21.8373 21.2583L6.20322 14.9771L5.81627 14.8211H2.15973V9.17585H5.81627L6.20322 9.01987L21.8373 2.73866V21.2583Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.c5bfda04.svg";
export { ForwardRef as ReactComponent };